/* eslint-disable react/prop-types */
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function DenseTable({
  headers,
  rows,
  height,
  filename,
  component,
  tableSpans,
}) {
  return (
    <>
      <TableContainer
        elevation={0}
        style={{ height: height }}
        component={Paper}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          {/* <ExcelExportButton
            rows={rows}
            columns={headers}
            filename={filename}
          /> */}
          <div>{component}</div>
        </div>
        <Table
          stickyHeader
          sx={{ width: "100%", overflow: "auto" }}
          size='small'
          aria-label='a dense table'>
          <TableHead>
            {tableSpans}
            <TableRow style={{ backgroundColor: "#ccc" }}>
              {headers.map((header, index) => (
                <TableCell
                  style={{
                    backgroundColor: "#cbd5e1",
                    fontSize: "11px",
                    width: header.width,
                    padding: 0,
                    paddingLeft: 1,
                  }}
                  key={index}
                  align={header.align || "left"}>
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                {headers.map((header, colIndex) => (
                  <TableCell
                    style={{ fontSize: "11px" }}
                    key={colIndex}
                    align={header.align || "left"}>
                    {row[header.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Button Group for controlling height */}
    </>
  );
}
